import {Component, Input, OnInit} from "@angular/core";
import {FormatService} from "../../../services/format.service";

@Component({
    selector: 'app-gotourl',
    templateUrl: './go-to-url.component.html',
})
export class GoToUrlComponent implements OnInit{

    @Input('url') url: string;
    constructor(
        public formatServ: FormatService
    ){}

    ngOnInit(){
    }

    goTo(string){
        this.formatServ.gotToUrl(string, true)
    }
}


// WEBPACK FOOTER //
// /Users/moe.dchater/personal/firebase-projects/hosting/src/app/projects/shared/go-to-url/go-to-url.component.ts